module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_2@2x.d817d5b.webp";